<carousel>
	<slide *ngFor="let viewModel of viewModels">
		<a routerLink="/technologies/{{viewModel.technologyCategoryId}}" routerLinkActive="active">

			
			<img [src]="organizationService.dynamicUri(viewModel.carouselImageUrl)" />
		</a>
	</slide>
</carousel>
